import {I18n} from '@aws-amplify/core';

import {SimplePageHeader,} from '@flexinet/ui-components';
import {usePageHeaderTools} from "../hooks/usePageHeaderTools.tsx";


export const IndexPageHeader = () => {
    const {tools} = usePageHeaderTools();

    return (
        <SimplePageHeader
            title={I18n.get('Account Applications')}
            tools={tools}
        />
    );
};